import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { iEnv } from '../../environments/iEnv.interface';

@Injectable({
  providedIn: 'root',
})
export class BaseConfigurationService {
  private environment: iEnv;

  constructor() {
    this.environment = environment;
  }

  public getBackendEndpoint(): string {
    return this.environment['backEndpoint'];
  }

  public getMainTitle(): string {
    return this.environment['mainTitle'];
  }
}
